import initializeExtensibilityContext from './initializeExtensibilityContext';
import runContextualEvaluation from './runContextualEvaluationAndUpdate';
import { isContextualScenario } from './ContextualChecker';
import { isPersistentTaskpaneEnabled } from 'owa-addins-feature-flags';
import { populatePersistedAddins } from 'owa-addins-persistent';
import {
    initializeExtensibilityHostItem,
    whenExtensibilityContextInitialized,
} from 'owa-addins-store';
import {
    lazyInitializeExtensibilityFrameworkComponent,
    onItemNavigation,
    SelectionType,
} from 'owa-addins-view';
import { initializeExtensibilityNotifications } from 'owa-addins-apis';
import { addAdapter, MessageComposeAdapter, MessageReadAdapter } from 'owa-addins-adapters';

/** @param renderTaskPaneInPanel This should be called with the same value everywhere in the application */
export default async function initializeAddinsForItem(
    index: string,
    adapter: MessageComposeAdapter | MessageReadAdapter,
    renderTaskPaneInPanel: boolean = true,
    targetWindow: Window = window /*fallback is main window*/
) {
    addAdapter(index, adapter);
    initializeExtensibilityHostItem(index);
    if (isContextualScenario(adapter.mode)) {
        const readAdapter = adapter as MessageReadAdapter;
        whenExtensibilityContextInitialized(initializeContextualTerms(readAdapter, index));
    }
    initializeExtensibilityNotifications(index);
    await populatePersistedAddins(adapter.mode);
    await initializeExtensibilityContext();
    isPersistentTaskpaneEnabled() && onItemNavigation(SelectionType.Single, index, targetWindow);
    lazyInitializeExtensibilityFrameworkComponent(renderTaskPaneInPanel, index, targetWindow);
}

function initializeContextualTerms(readAdapter: MessageReadAdapter, index: string): () => void {
    return () => runContextualEvaluation(readAdapter.getItem(), index);
}
